module.exports = __webpack_public_path__ + "static/media/ready-for-my-closeup_750px.163fe8cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ready-for-my-closeup_750px.jpg
// module id = 252
// module chunks = 1